export class Competitor {
  id: number;
  country: string;
  firstName: string;
  lastName: string;
  idNumber: string;
  dateOfBirth: Date;
  address: string;
  phone: string;
  role: Role;
  userId: number;

  constructor(
    id = null,
    country = '',
    firstName = '',
    lastName = '',
    idNumber = '',
    dateOfBirth = new Date(),
    address = '',
    phone = '',
    role = Role.USER,
    userId = null
  ) {
    this.id = id;
    this.country = country;
    this.firstName = firstName;
    this.lastName = lastName;
    this.idNumber = idNumber;
    this.dateOfBirth = dateOfBirth;
    this.address = address;
    this.phone = phone;
    this.role = role;
    this.userId = userId;
  }
}

export class CompetitorSimple {
  id: number;
  country: string;
  firstName: string;
  lastName: string;

  constructor(
    id = null,
    country = '',
    firstName = '',
    lastName = '',
  ) {
    this.id = id;
    this.country = country;
    this.firstName = firstName;
    this.lastName = lastName;
  }
}

export enum Role {
  ADMIN,
  CREATOR,
  USER
}
